import React from "react";
import { BrowserRouter } from "react-router-dom";
import PageRouter from "./PageRouter";
import HtmlLang from "../components/Shared/HtmlLang";

export default function DomainRouter() {
  return (
    <BrowserRouter>
      <HtmlLang />
      <PageRouter />
    </BrowserRouter>
  );
}
